/**
 * Tile Layer URL Configurations
 *
 * USGS and ESRI basemap tile services for topographic and satellite imagery.
 */

export const USGS_TOPO_URL =
  'https://basemap.nationalmap.gov/arcgis/rest/services/USGSTopo/MapServer/tile/{z}/{y}/{x}'

export const USGS_IMAGERY_URL =
  'https://basemap.nationalmap.gov/arcgis/rest/services/USGSImageryTopo/MapServer/tile/{z}/{y}/{x}'

export const ESRI_SATELLITE_URL =
  'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}'

/**
 * Tile layer options shared across all basemap layers.
 */
export const TILE_OPTIONS = {
  maxZoom: 16,
  attribution:
    'Tiles &copy; <a href="https://www.usgs.gov/">USGS</a> | Esri',
}

/**
 * Per-layer option overrides keyed by layer name.
 */
export const LAYER_OPTIONS = {
  topo: {
    ...TILE_OPTIONS,
    attribution: 'Tiles &copy; <a href="https://www.usgs.gov/">USGS</a>',
  },
  imagery: {
    ...TILE_OPTIONS,
    attribution:
      'Tiles &copy; <a href="https://www.usgs.gov/">USGS</a> | Imagery',
  },
  satellite: {
    ...TILE_OPTIONS,
    maxZoom: 18,
    attribution:
      'Tiles &copy; <a href="https://www.esri.com/">Esri</a> | World Imagery',
  },
}
